import { Switch } from '@/shared/components/ui/switch';
import { Label } from '@/shared/components/ui/label';

interface ToggleSwitchProps {
  checked: boolean;
  onCheckedChange: (value: boolean) => void;
  label: string;
  disabled?: boolean;
  id: string;
  'data-testid'?: string;
}

export function ToggleSwitch({
  checked,
  onCheckedChange,
  label,
  disabled = false,
  id,
  'data-testid': testId,
}: ToggleSwitchProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch
        id={id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        data-testid={testId}
      />
      <Label htmlFor={id} className="text-sm text-muted-foreground cursor-pointer">
        {label}
      </Label>
    </div>
  );
}
